import ButtonMenu from "../Buttons/ButtonMenu";
import LanguageFlag from "./LanguageFlag";
import { APP_SUPPORTED_LANGUAGES } from "../../utils/i18nLanguage";

const LanguageSwitcher = ({
  language = "en",
  onChangeLanguage = () => {},
  colorButton = "secondary",
  sx = {},
  sxMenu = {},
  anchorOrigin = null,
  transformOrigin = null,
}) => {
  const languageOptions = APP_SUPPORTED_LANGUAGES.map((code) => ({
    icon: <LanguageFlag language={code} sx={{ mr: 0 }} />,
    label: code,
    onClick: () => onChangeLanguage(code),
  }));

  return (
    <ButtonMenu
      showLabel={false}
      showOptionLabels={false}
      options={languageOptions}
      iconButton={<LanguageFlag language={language || "en"} />}
      colorButton={colorButton}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      sx={sx}
      sxMenu={sxMenu}
    />
  );
};

export default LanguageSwitcher;
